import axios from "../../utils/axios";
import { Button } from "djinn-components";
import React, { useState } from "react";
import { toast } from "react-toastify";

interface AccountBillingHistoryProps {}

const AccountBillingHistory: React.FC<AccountBillingHistoryProps> = () => {
  const [loading, setLoading] = useState(false);

  const pushToStripeDashboard = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get("stripe/create-portal-link");
      window.location.replace(data.url);
    } catch (error) {
      toast("Failed to load account details please try again later", {
        type: "error",
      });
    }
    setLoading(false);
  };
  return (
    <div className="max-w-5xl p-10 mx-auto bg-gray-700 rounded-xl text-white flex items-center justify-center flex-col">
      <p className="text-lg max-w-lg text-center mb-5 text-gray-400">
        Visit your stripe customer dashboard to view invoices, manage
        subscriptions and manage payment methods.
      </p>
      <div className="w-56">
        <Button
          type="button"
          onClick={() => pushToStripeDashboard()}
          text="Open Stripe Dashboard"
          disabled={loading}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default AccountBillingHistory;
